import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { throttle } from 'lodash';
import {
  AppBar,
  IconButton,
  List,
  ListItem,
  CircularProgress,
} from 'material-ui';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import { loadAffiliates, searchBy } from './AffiliateState';
import { selectAffiliate } from '../../app/state';
import { AffiliateType } from '../../types';
import { HistoryType } from '../../types/router';
import { PageLoader } from '../../components/PageWrapper';
import StatusBarStyle from '../../components/StatusBarStyle';
import { localize } from '../../i18n';

class Affiliates extends React.Component {
  constructor(...args) {
    super(...args);

    this.state = {
      searchPhrase: '',
    };

    this.performSearch = throttle((phrase) => {
      this.props.dispatch(searchBy(phrase));
    }, 300);
  }

  componentWillMount() {
    this.props.dispatch(loadAffiliates());
  }

  handleSelect(affiliate) {
    const {
      dispatch,
      hasAffiliate,
    } = this.props;

    dispatch(selectAffiliate(affiliate))
      .then(() => hasAffiliate && this.goMain());
  }

  handleSearch(phrase) {
    this.performSearch(phrase);
    this.setState({ searchPhrase: phrase });
  }

  goMain() {
    const {
      history,
    } = this.props;

    history.push('/access/requests');
  }

  render() {
    const {
      affiliates: {
        filteredAffiliates: affiliates,
        isLoading,
      },
      hasAffiliate,
    } = this.props;

    const styles = {
      wrapper: {
        marginTop: '16px',
      },
      appBar: {
        backgroundColor: 'white',
        position: 'fixed',
        top: '0',
        borderBottom: '1px solid #E0E0E0',
      },
      list: {
        backgroundColor: 'white',
        borderBottom: '1px solid #E0E0E0',
      },
      icon: {
        fill: 'black',
        color: 'black',
      },
      input: {
        width: '100%',
        height: '48px',
        border: 'none',
        fontSize: '16px',
        verticalAlign: 'middle',
      },
    };

    const hasContent = affiliates.length;

    const getAffiliateDesc = ({ attributes: { country, city, province, postal_code: postalCode } }) =>
      [country, city, province, postalCode].filter(i => i).join(', ') || 'none';

    const renderAffiliate = () => affiliate => (
      <ListItem
        key={affiliate.id}
        primaryText={affiliate.attributes.name}
        secondaryText={getAffiliateDesc(affiliate)}
        onClick={() => this.handleSelect(affiliate)}
      />
    );

    const { searchPhrase } = this.state;

    return (
      <div style={styles.wrapper}>
        <StatusBarStyle color="white" barStyle="dark-content" />
        <AppBar
          style={styles.appBar}
          iconStyleLeft={styles.icon}
          iconElementLeft={
            searchPhrase ?
              (<IconButton onClick={() => this.handleSearch('')}>
                <CloseIcon color="black" />
              </IconButton>) :
              (<IconButton onClick={() => this.goMain()} disabled={!hasAffiliate}>
                <ArrowBack color="black" />
              </IconButton>)
          }
          iconElementRight={
            (isLoading && hasContent) ? <IconButton><CircularProgress size={24} /></IconButton> : null
          }
          zDepth={0}
          title={
            <input
              value={searchPhrase}
              onChange={({ target: { value } }) => this.handleSearch(value)}
              type="text"
              style={styles.input}
              placeholder={this.props.t('Type to search property')}
            />
          }
        />
        { (isLoading && !hasContent) ?
          <PageLoader title={this.props.t('Getting properties')} /> :
          (<List style={styles.list}>
            {affiliates.map(renderAffiliate(true))}
          </List>)
        }
      </div>
    );
  }
}

Affiliates.propTypes = {
  affiliates: PropTypes.shape({
    filteredAffiliates: PropTypes.arrayOf(AffiliateType),
    prevSelected: PropTypes.arrayOf(AffiliateType),
    isLoading: PropTypes.bool,
    filterPhrase: PropTypes.string,
  }),
  history: HistoryType,
  hasAffiliate: PropTypes.bool,
  dispatch: PropTypes.func,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = ({ session: { affiliateId }, views: { affiliates } }) => ({
  affiliates,
  hasAffiliate: !!affiliateId,
});

export default localize(connect(mapStateToProps)(Affiliates));



// WEBPACK FOOTER //
// ./src/views/affiliates/Affiliates.js